import {
  EVENTS,
  HUBSPOT_CONNECT,
} from "../reducers/hubspot-reducer";
import hubspotService from "../services/hubspotService";

// Reset action
export const resetHubspotReducer = () => ({
  event: EVENTS.RESET_HUBSPOT_REDUCER,
  type: null,
});

// Save Domain Key actions
const saveDomainKeyStart = () => ({
  event: EVENTS.HUBSPOT_CONNECT,
  type: HUBSPOT_CONNECT.START,
});

const saveDomainKeySuccess = (data) => ({
  event: EVENTS.HUBSPOT_CONNECT,
  type: HUBSPOT_CONNECT.SUCCESS,
  payload: data,
});

const saveDomainKeyError = (error) => ({
  event: EVENTS.HUBSPOT_CONNECT,
  type: HUBSPOT_CONNECT.ERROR,
  payload: error,
});

export const saveDomainKey = (formData) => async (dispatch) => {
  dispatch(saveDomainKeyStart());
  try {
    const response = await hubspotService.saveDomainKey(formData);
    dispatch(saveDomainKeySuccess(response));
    return response;
  } catch (error) {
    dispatch(saveDomainKeyError(error));
    throw error;
  }
};
